/*
These functions make sure WordPress
and Foundation play nice together.
*/

/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function () {
	var count = 0;

	jQuery('#frm_form_4_container .frm_checkbox, #frm_form_4_container .frm_radio').each(function () {
		if (jQuery(this).find('input').is(":checked")) {
			jQuery(this).find('label').addClass("active");
		}
	});


	jQuery("#frm_form_4_container .frm_checkbox").click(function () {
		count++;

		if (count == 2) {
			if (jQuery(this).find('label').hasClass("active")) {
				jQuery(this).find('label').removeClass("active");
			} else {
				jQuery(this).find('label').addClass("active");
			}
			count = 0;
		}
	});

	jQuery("#frm_form_4_container .frm_radio").click(function () {
		count++;
		if (count == 2) {
			jQuery(this).parent().find('label').removeClass("active");
			if (jQuery(this).find('label').hasClass("active")) {
				jQuery(this).find('label').removeClass("active");
			} else {
				jQuery(this).find('label').addClass("active");
			}
			count = 0;
		}
	});

	jQuery(".hamburger, .js-off-canvas-overlay").click(function() {
		jQuery('.hamburger').toggleClass("is-active");
		jQuery('.header').toggleClass("is-active");
	});

	jQuery(".infobox .innerinfo").hover(
		function () {
			var height = jQuery(this).find(".hoverfield").height();
			jQuery(this).find("h2").css("bottom", height);
		}, function () {
			jQuery(this).find("h2").css("bottom", "0");
		}
	);


	//set readonly on frm_total class
	jQuery('.frm_total').find('input').attr("readonly", "readonly");


	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Makes sure last grid item floats left
	jQuery('.archive-grid .columns').last().addClass('end');

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
		if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
			jQuery(this).wrap("<div class='widescreen flex-video'/>");
		} else {
			jQuery(this).wrap("<div class='flex-video'/>");
		}
	});

	// Sandwitch Menü Effekt
	"use strict";
	var toggles = document.querySelectorAll(".c-hamburger");

	for (var i = toggles.length - 1; i >= 0; i--) {
		var toggle = toggles[i];
		toggleHandler(toggle);
	}

	function toggleHandler(toggle) {
		toggle.addEventListener("click", function (e) {
			e.preventDefault();
			(this.classList.contains("is-active") === true) ? this.classList.remove("is-active") : this.classList.add("is-active");
		});
	}

	jQuery('.katon').click(function(){
		jQuery(this).toggleClass('active');
		jQuery(this).next().toggleClass('active');
	});


	if(jQuery('.schnitt').length)
	{
		var count_element = jQuery('.schnitt').length;
		console.log(count_element);

		if(count_element <= 6){
			jQuery('.alle').hide();
		}
	}

	jQuery('.alle').click(function(){
		if(jQuery('.projektstartslider').hasClass('unslick')){
			jQuery('.projektstartslider').slick({
				dots: true,
				infinite: true,
				speed: 300,
				slidesToShow: 3,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
							infinite: true,
							dots: true
						}
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			});
			jQuery('.projektstartslider').removeClass('unslick');
			jQuery(this).html('Alle anzeigen');
			var container = jQuery("html,body");
			var scrollTo = jQuery('.projektstartslider');
			container.animate({scrollTop: scrollTo.offset().top - 100, scrollLeft: 0},300);
			jQuery("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 466 841.9'><defs><rect x='21' y='13.9' width='429' height='813.6'/></defs><clipPath><use xlink:href='#SVGID_1_'/></clipPath><path d='M443 403.6L60.2 20.9c-9-9-23.5-9-32.5 0 -9 9-9 23.5 0 32.5l366.4 366.4L27.8 786.2c-9 9-9 23.5 0 32.5 4.4 4.4 10.4 6.8 16.2 6.8 5.8 0 11.7-2.2 16.1-6.8l382.8-382.7C451.8 427.1 451.8 412.5 443 403.6L443 403.6zM443 403.6' clip-path='url(#SVGID_2_)'/></svg>").appendTo( ".projektstartslider .slick-next ,.projektstartslider .slick-prev");
		}else{
			jQuery('.projektstartslider').slick('unslick');
			jQuery('.projektstartslider').addClass('unslick');
			jQuery(this).html('Weniger anzeigen');
		}

	});

	jQuery('.gallery').featherlightGallery({
		gallery: {
			fadeIn: 300,
			fadeOut: 300,
		},
		openSpeed: 300,
		closeSpeed: 300
	});

	jQuery('body').delay(350).css({'overflow': 'visible'});

});

jQuery(document).ajaxComplete(function () {
	jQuery('#frm_form_4_container .frm_checkbox, #frm_form_4_container .frm_radio').each(function () {
		if (jQuery(this).find('input').is(":checked")) {
			jQuery(this).find('label').addClass("active");
		}
	});

	count = 0;
	jQuery("#frm_form_4_container .frm_checkbox").click(function () {
		count++;
		if (count == 2) {
			if (jQuery(this).find('label').hasClass("active")) {
				jQuery(this).find('label').removeClass("active");
			} else {
				jQuery(this).find('label').addClass("active");
			}
			count = 0;
		}
	});

	jQuery("#frm_form_4_container .frm_radio").click(function () {
		count++;
		if (count == 2) {
			jQuery(this).parent().find('label').removeClass("active");
			if (jQuery(this).find('label').hasClass("active")) {
				jQuery(this).find('label').removeClass("active");
			} else {
				jQuery(this).find('label').addClass("active");
			}
			count = 0;
		}
	});

	jQuery("body").fadeIn(500);

	//set readonly on frm_total class
	jQuery('.frm_total').find('input').attr("readonly", "readonly");


	if (jQuery(".frm_rootline_single").length == 4) {
		jQuery("#frm_form_4_container input.frm_page_2").css("background-image", "url('/wp-content/themes/JointsWP-master/assets/images/position.svg') !important;");
		jQuery("#frm_form_4_container input.frm_page_3").css("background-image", "url('/wp-content/themes/JointsWP-master/assets/images/amount.svg') !important;");
		jQuery("#frm_form_4_container input.frm_page_4").css("background-image", "url('/wp-content/themes/JointsWP-master/assets/images/info.svg') !important;");
	}
});


